import React, { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';

import LoadingCircle from './LoadingCircle';

const LazyRoute = ({ page, ...rest }) => {
  const Component = lazy(() => import(`../pages/${page}`));

  const LazyComponent = props => (
    <Suspense fallback={<LoadingCircle />}>
      <Component {...props} />
    </Suspense>
  );

  return <Route component={LazyComponent} {...rest} />;
};

export default LazyRoute;
